import { routeName } from '@/constants/routeName';
import List from '@/views/StoreWorkProcess/List/index.vue';
import Edit from '@/views/StoreWorkProcess/Edit/index.vue';
import Detail from '@/views/StoreWorkProcess/Detail/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'store-work-process',
        name: routeName.STORE_WORK_PROCESS,
        component: List,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 작성 */
    {
        path: 'store-work-process/create',
        name: routeName.STORE_WORK_PROCESS_CREATE,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 수정 */
    {
        path: 'store-work-process/:itemId/edit',
        name: routeName.STORE_WORK_PROCESS_EDIT,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 댓글 작성 */
    {
        path: 'store-work-process/:itemId/create-reply',
        name: routeName.STORE_WORK_PROCESS_CREATE_REPLY,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 답변 수정 */
    {
        path: 'store-work-process/:itemId/edit-reply',
        name: routeName.STORE_WORK_PROCESS_EDIT_REPLY,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 상세조회 or 댓글 상세조회 */
    {
        path: 'store-work-process/:itemId/detail',
        name: routeName.STORE_WORK_PROCESS_DETAIL,
        component: Detail,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
];
